// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityDashboardPage_container__dKGJJ","header":"CommunityDashboardPage_header__tmiMT","title":"CommunityDashboardPage_title__z5E3x"};